﻿import PropTypes from "prop-types";

import { useNavigate } from "react-router-dom";

import classes from "./error.module.scss";

const Error = ({ error, message }) => {
	const navigate = useNavigate();

	return (
		<div className={classes.content}>
			<div className={classes.main}>
				<div className={classes.error}>{error} Error</div>
				<div className={classes.message}>{message}</div>

				<div className={classes.buttonback} onClick={() => navigate("/")}>
					Volver
				</div>
			</div>
		</div>
	);
};

Error.propTypes = {
	error: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
};

export default Error;
